/**************************************************
 * Nombre:       Tarjeta_Fecha
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {CalendarMonth} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import dayjs from "dayjs";

const Tarjeta_Fecha = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Grid container size={{xs: 2, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <CalendarMonth sx={{fill: theme.palette.primary.main, width: 48, height: 48}}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 10, sm: 12, md: 9}}
                sx={{pl: sCell ? 1 : 0}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14, lineHeight: 1.2}}>INICIO</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{color: theme.palette.secondary.main, fontWeight: 600, fontSize: 20, lineHeight: 1.1}}>
                        {dayjs(item.fechaIncio).format('DD-MM-YYYY')}
                    </Typography>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Fecha